import React from 'react';

import ModalButtonKey from 'test/lib/cypress/shared/ModalButtonKey';
import {ButtonStyle} from 'ui-library/buttons/Button';
import Modal from 'ui-library/modals/Modal';

interface RemoveOutputSchemaModalProps {
  onRequestSubmit: () => void;
  onRequestClose: () => void;
}

export default function RemoveOutputSchemaModal(props: RemoveOutputSchemaModalProps): JSX.Element {
  return (
    <Modal
      onRequestClose={props.onRequestClose}
      onRequestSubmit={props.onRequestSubmit}
      title="Remove output schema?"
      medium={true}
      buttons={[
        {
          cancel: true,
          text: 'Cancel',
        },
        {
          submit: true,
          text: 'Remove output schema',
          style: ButtonStyle.NEGATIVE,
          dataTestAttrs: {
            component: 'RemoveOutputSchemaModal',
            element: 'button',
            key: ModalButtonKey.REMOVE,
          },
        },
      ]}
    >
      <p className="u-spacing-bottom">
        Previous output schema configurations will be lost. Output schema cannot be added again after the task
        schema has been created.
      </p>
    </Modal>
  );
}
